<template>
  <b-card v-if="!!option" id="page-company-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.subscriptions.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="subscription.name"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('subscriptionType'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('subscriptionType'))"
                  label-for="typesSubs"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="subscription.idCatType"
                    input-id="typesSubs"
                    :options="listTypeSubs"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('subscriptionType'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.typesSubs.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('price'))" label-for="priceId">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('price'))"
                  rules="required|integer"
                >
                  <b-form-input
                    id="priceId"
                    v-model="subscription.price"
                    type="number"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('price'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('coinTypes'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('coinTypes'))"
                  label-for="coinTypes"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="subscription.idCatCoinType"
                    input-id="coinTypes"
                    :options="listTypeCoins"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('coinTypes'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.typesSubs.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('durationInDays'))"
                label-for="durationInDays"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('durationInDays'))"
                  rules="required|integer"
                >
                  <b-form-input
                    id="durationInDays"
                    v-model="subscription.durationInDays"
                    type="number"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('durationInDays'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('cantMessage'))"
                label-for="priceId"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('cantMessage'))"
                  rules="required|integer"
                >
                  <b-form-input
                    id="priceId"
                    v-model="subscription.cantMessage"
                    type="number"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('cantMessage'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('description'))"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="subscription.description"
                  :placeholder="$t(label('description'))"
                  :disabled="!isSaveMode"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BForm,
  BFormTextarea,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, integer } from "@validations";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import {
  getSubcription,
  createOrEditSubcription,
} from "@core/api/request/subcription";
import { getCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

const subscription = {
  guid: null,
  name: null,
  idCatType: null,
  price: 0,
  idCatCoinType: null,
  description: "",
  durationInDays: 0,
  idSubscription: null,
  cantMessage: null,
};

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    vSelect,
    BFormTextarea,
  },

  directives: {
    Ripple,
  },

  data: () => ({
    isSaveMode: true,
    required,
    integer,
    subscription: Object.assign(subscription),
    option: "",
    typesSubsSelected: null,
    coinTypsSelected: null,
    listTypeSubs: [],
    listTypeCoins: [],
    itemsPage: 1,
    itemsRows: 999,
  }),

  created() {
    localize("es");
    this.initialize();
    this.loadCatData();
  },

  computed: {},

  mounted() {},

  methods: {
    label(field) {
      return `pages.subscriptions.form.label.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    chargeParams(key) {
      let arrParams = [];

      arrParams.push(`itemsPage,${this.itemsPage}`);

      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "typeSub":
          arrParams.push("guidCatalog, e1e0d113-b268-4c02-b190-fc2683621c95");
          break;
        case "coinTyps":
          arrParams.push("guidCatalog, 20ce3c04-4594-4398-adae-f8def7bd8f25");
          break;
      }

      return getParams(arrParams);
    },

    initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "subcriptions" }).catch(() => {});
      }
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        // option 2 to show, option 3 to edit
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            router.push({ name: "subcriptions" }).catch(() => {});
          }
          this.isSaveMode = this.option === 2 ? false : true;
          this.getSubcription(this.$route.params.guid);
          break;
      }
    },

    getSubcription(guid) {
      showLoading();
      getSubcription(guid)
        .then((resp) => {
          const subscription = _.get(resp, "data");
          this.subscription = Object.assign(this.subscription, {
            guid: subscription.guid || null,
            name: subscription.name || null,
            idCatType: subscription.idCatType || null,
            price: subscription.price || 0,
            idCatCoinType: subscription.idCatCoinType || null,
            description: subscription.description || null,
            durationInDays: subscription.durationInDays || 0,
            idSubscription: subscription.idSubscription || null,
          });
          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
        });
    },

    async loadCatData() {
      showLoading();
      try {
        const paramTypeSub = this.chargeParams("typeSub");
        const paramCoinTyps = this.chargeParams("coinTyps");
        const [resultTypeSubs, resultCoinTyps] = await Promise.all([
          getCatalog(paramTypeSub),
          getCatalog(paramCoinTyps),
        ]);
        stopLoading();
        this.listTypeSubs = _.get(resultTypeSubs, "data.listOfItems.items");
        this.listTypeCoins = _.get(resultCoinTyps, "data.listOfItems.items");
      } catch (error) {
        console.log("error", error);
        stopLoading();
        this.alertToast("danger", `Alerta codigo`, error.message);
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.subscription.price = parseInt(this.subscription.price) || 0;
          this.subscription.durationInDays =
            parseInt(this.subscription.durationInDays) || 0;
          this.subscription.cantMessage =
            parseInt(this.subscription.cantMessage) || 0;
          const guid = this.option === 1 ? null : this.subscription.guid;
          showLoading();
          createOrEditSubcription(this.subscription, guid)
            .then((response) => {
              console.log(response);
              stopLoading();
              this.alertToast(
                "success",
                `Alerta`,
                `${
                  this.option != 3 ? "Registro exitoso" : "Registro actualizado"
                }`,
              );
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", "Alerta error", error.message);
            });
        }
      });
    },

    onCancel() {
      Object.assign(this.subscription, {
        guid: null,
        name: null,
        idCatType: null,
        price: 0,
        idCatCoinType: null,
        description: null,
        durationInDays: 0,
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },
  },
};
</script>

<style lang="scss">
@import "../../../../public/loader.css";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
